<template>
  <div id="app">
    <component :is="layout"></component>
    <Onboarding v-if="onboardingState" @closeOnboarding="closeOnboarding" />
    <Modal v-if="showDataModal" :noClose="true">
      <template v-slot:modalBody>
        <div class="modal__body">
          <div class="_mb-8">
            <div class="_fs-20 _lh-24 _fw-700 _tc-dark _mb-2">
              Укажите ваши данные
            </div>
            <div class="_fs-16 _lh-24 _fw-400 _mb-4 _tc-dark-grey">
              <div class="d-flex">
                <div class="_mr-2" style="flex-shrink: 0">
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.4998 6.66675V10.0001M10.4998 13.3334H10.5082M18.8332 10.0001C18.8332 14.6025 15.1022 18.3334 10.4998 18.3334C5.89746 18.3334 2.1665 14.6025 2.1665 10.0001C2.1665 5.39771 5.89746 1.66675 10.4998 1.66675C15.1022 1.66675 18.8332 5.39771 18.8332 10.0001Z"
                      stroke="#DC8633"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                Чтобы продолжить использовать сайт Herbalife Академия введите
                ваши данные в соответствующие поля и нажмите сохранить.
              </div>
            </div>
            <div class="_fs-16 _lh-24 _tc-green-second _mb-8">
              {{ $t("cabinet.dashboard.sections[1].priseModals[0].tip") }}
            </div>
            <div class="_mb-8">
              <v-input
                v-if="user && Object.keys(user).length && !user.first_name"
                :class="{ '_mb-10': !name.state }"
                class="_mb-4 w-100"
                v-model="name.value"
                :state="name.state ? null : false"
                label-style="label-border"
                :label="$t('fields_labels.name') + '*'"
                :state-invalid-text="name.error"
                @change="validate(['name'])"
                @blur="validate(['name'])"
              >
                <template v-slot:clear>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1L1 13M1 1L13 13"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </template>
              </v-input>
              <v-input
                :class="{ '_mb-10': !secondName.state }"
                class="_mb-4 w-100"
                v-if="user && Object.keys(user).length && !user.last_name"
                v-model="secondName.value"
                :state="secondName.state ? null : false"
                label-style="label-border"
                :label="$t('fields_labels.surname')"
                :state-invalid-text="secondName.error"
                @change="validate(['secondName'])"
                @blur="validate(['secondName'])"
              >
                <template v-slot:clear>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1L1 13M1 1L13 13"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </template>
              </v-input>
              <div class="d-md-flex align-start">
                <v-input
                  v-if="
                    user && Object.keys(user).length && !user.ds_mailing_country
                  "
                  :class="{ '_mb-10': !country.state }"
                  class="_mb-4 _mr-7 _mr-xs-0 w-100"
                  v-model="country.value"
                  :state="country.state ? null : false"
                  label-style="label-border"
                  :label="$t('fields_labels.country') + '*'"
                  :state-invalid-text="country.error"
                  @change="validate(['country'])"
                  @blur="validate(['country'])"
                >
                  <template v-slot:clear>
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13 1L1 13M1 1L13 13"
                        stroke="#B2B4B2"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </template>
                </v-input>
                <v-input
                  v-if="
                    user && Object.keys(user).length && !user.ds_mailing_city
                  "
                  :class="{ '_mb-10': !city.state }"
                  class="_mb-4 w-100"
                  v-model="city.value"
                  :state="city.state ? null : false"
                  label-style="label-border"
                  :label="$t('fields_labels.city')"
                  :state-invalid-text="city.error"
                  @change="validate(['city'])"
                  @blur="validate(['city'])"
                >
                  <template v-slot:clear>
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13 1L1 13M1 1L13 13"
                        stroke="#B2B4B2"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </template>
                </v-input>
              </div>
              <div>
                <v-select
                  :searchable="false"
                  v-model="status.value"
                  class="selectaria__select selectaria__select_long"
                  :class="{ selectaria_error: status.error }"
                  :options="statusList"
                  label="label"
                  :reduce="(lectors) => lectors.value"
                  :closeOnSelect="true"
                  :placeholder="'Выберите подходящий вариант'"
                  @change="validate(selectVal)"
                >
                  <template v-slot:no-options="{ searching }">
                    <template v-if="searching">
                      {{ $t("interface.searchEmpty") }}
                    </template>
                    <template v-else>
                      {{ $t("interface.listEmpty") }}
                    </template>
                  </template>
                  <template #selected-option-container="{ option }">
                    <span class="placeholder-immitation">
                      Выберите ваш статус
                    </span>
                    <span
                      class="placeholder-immitation placeholder-immitation_overflow"
                      ><span>{{ option.label }}</span></span
                    >
                  </template>
                  <template #open-indicator="{ attributes }">
                    <span v-bind="attributes">
                      <svg
                        width="13"
                        height="8"
                        viewBox="0 0 13 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5 1.5L6.5 6.5L1.5 1.5"
                          stroke="#B2B4B4"
                          stroke-linecap="square"
                        />
                      </svg>
                    </span>
                  </template>
                </v-select>
                <div
                  class="selectaria__error"
                  v-if="status.error"
                  v-html="status.error"
                ></div>
              </div>
            </div>
          </div>
          <div
            class="d-flex justify-between align-center _mt-8 direction-column-reverse direction-lg-row"
          >
            <AppBtn
              class="w-100 w-md-auto _mx-auto"
              @click.native="saveUserData"
            >
              <span class="_fs-16 _lh-24 _py-3 _py-sm-3 _px-4 _px-xs-0">
                {{ $t("cabinet.save") }}
              </span>
            </AppBtn>
          </div>
        </div>
      </template>
    </Modal>
    <Modal v-if="authState" @close="modalToggle('authState', false)">
      <template v-slot:modalBody>
        <div class="modal__body">
          <div
            class="modal__title _fs-sm-24 _lh-sm-32 _fs-32 _lh-38 _fw-700 _tc-dark _mb-6"
            v-html="$t('modals.auth.title')"
          ></div>
          <v-input
            :class="{ '_mb-10': !email.state }"
            class="_mb-6"
            v-model="email.value"
            :state="email.state ? null : false"
            clearable
            label-style="label-border"
            :label="$t('fields_labels.herbalifeId')"
            :state-invalid-text="email.error"
          >
            <template v-slot:clear>
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 1L1 13M1 1L13 13"
                  stroke="#B2B4B2"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </template>
          </v-input>
          <v-input
            :class="{ '_mb-6': !password.state }"
            class="_mb-2"
            v-model="password.value"
            :state="password.state ? null : false"
            :type="password.type"
            label-style="label-border"
            :label="$t('fields_labels.password')"
            :state-invalid-text="password.error"
            @change="validate(['password'])"
            @blur="validate(['password'])"
          >
            <template v-slot:icon-append>
              <div @click="showPass">
                <svg
                  v-if="password.type === 'text'"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1152_1106)">
                    <path
                      d="M14.12 14.12C13.8454 14.4147 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.481 9.80385 14.1962C9.51897 13.9113 9.29439 13.5719 9.14351 13.1984C8.99262 12.8248 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2218 9.18488 10.8538C9.34884 10.4859 9.58525 10.1546 9.88 9.88M1 1L23 23M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.6819 3.96914 7.65661 6.06 6.06L17.94 17.94ZM9.9 4.24C10.5883 4.07888 11.2931 3.99834 12 4C19 4 23 12 23 12C22.393 13.1356 21.6691 14.2047 20.84 15.19L9.9 4.24Z"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1152_1106">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <svg
                  v-else
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </template>
          </v-input>
          <div
            class="d-md-flex justify-start align-center _mb-8 _mt-8 _mb-sm-4 d-block"
          >
            <!-- <AppBtn
              @click.native="forgotPasswordClick()"
              :btnClass="'btn_underline-grey'"
            >
              <div class="_fs-16 _lh-24">
                {{ $t('modals.auth.forgot_password') }}
              </div>
            </AppBtn> -->
            <!-- <AppBtn
              @click.native="modalToggle('helpState', true)"
              :btnClass="'btn_secondary'"
              class="_ml-auto w-100 w-md-auto _mt-sm-4"
            >
              <span class="_py-4 _py-sm-3 _px-4 _px-xs-0 _fs-16 _lh-24">
                Нужна помощь
              </span>
            </AppBtn> -->
          </div>
          <div class="d-md-flex justify-start align-center d-block">
            <AppBtn @click.native="submit" class="_mr-auto w-100 w-md-auto">
              <span class="_py-4 _py-sm-3 _px-25 _px-xs-0 _fs-16 _lh-24">{{
                $t("interface.login")
              }}</span>
            </AppBtn>
            <!-- <AppBtn
              @click.native="registerClick()"
              :btnClass="'btn_underline'"
              class="_mx-auto _mt-sm-4"
            >
              <div class="_fs-16 _lh-24">{{ $t('interface.register') }}</div>
            </AppBtn> -->
          </div>
          <SocialAuth v-if="false" class="_mb-12" />
          <Telegram v-if="false" :analyticEventPrefix="'auth'" />
        </div>
      </template>
    </Modal>
    <Modal v-if="authSSOState" @close="modalToggle('authSSOState', false)">
      <template v-slot:modalBody>
        <div class="modal__body">
          <div
            class="modal__title _fs-sm-24 _lh-sm-32 _fs-32 _lh-38 _fw-700 _tc-dark _mb-6"
            v-html="$t('modals.auth.title')"
          ></div>
          <div
            class="_fs-16 _lh-24 _fw-400 _mb-8 _mt-4 _tc-white"
            style="
              padding: 16px 20px;
              background-color: #f37421;
              border-radius: 10px;
            "
          >
            <div class="d-flex">
              <div class="_mr-2" style="flex-shrink: 0">
                <svg
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.4998 6.66675V10.0001M10.4998 13.3334H10.5082M18.8332 10.0001C18.8332 14.6025 15.1022 18.3334 10.4998 18.3334C5.89746 18.3334 2.1665 14.6025 2.1665 10.0001C2.1665 5.39771 5.89746 1.66675 10.4998 1.66675C15.1022 1.66675 18.8332 5.39771 18.8332 10.0001Z"
                    stroke="#fff"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </div>
              {{ $t("modals.auth.warning") }}
            </div>
          </div>
          <v-input
            :class="{ '_mb-10': !email.state }"
            class="_mb-6"
            v-model="email.value"
            :state="email.state ? null : false"
            clearable
            label-style="label-border"
            :label="$t('fields_labels.SSO_login')"
            :state-invalid-text="email.error"
          >
            <template v-slot:clear>
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 1L1 13M1 1L13 13"
                  stroke="#B2B4B2"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </template>
          </v-input>
          <v-input
            :class="{ '_mb-12 _mb-sm-16': !password.state }"
            class="_mb-2"
            v-model="password.value"
            :state="password.state ? null : false"
            :type="password.type"
            label-style="label-border"
            :label="$t('fields_labels.password')"
            :state-invalid-text="password.error"
            @change="validate(['password'])"
            @blur="validate(['password'])"
          >
            <template v-slot:icon-append>
              <div @click="showPass">
                <svg
                  v-if="password.type === 'text'"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1152_1106)">
                    <path
                      d="M14.12 14.12C13.8454 14.4147 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.481 9.80385 14.1962C9.51897 13.9113 9.29439 13.5719 9.14351 13.1984C8.99262 12.8248 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2218 9.18488 10.8538C9.34884 10.4859 9.58525 10.1546 9.88 9.88M1 1L23 23M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.6819 3.96914 7.65661 6.06 6.06L17.94 17.94ZM9.9 4.24C10.5883 4.07888 11.2931 3.99834 12 4C19 4 23 12 23 12C22.393 13.1356 21.6691 14.2047 20.84 15.19L9.9 4.24Z"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1152_1106">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <svg
                  v-else
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </template>
          </v-input>
          <div
            class="d-md-flex justify-start align-center _mb-8 _mt-8 _mb-sm-4 d-block"
          >
            <AppBtn :btnClass="'btn_underline-grey'">
              <a
                style="color: inherit"
                href="https://accounts.myherbalife.com/ForgotPassword?appId=1&locale=ru-RU&redirect=https%3a%2f%2fwww.myherbalife.com%2f&checkds=1"
                target="_blank"
                class="_fs-16 _lh-24"
              >
                {{ $t("modals.auth.forgot_password") }}
              </a>
            </AppBtn>
          </div>
          <div class="d-md-flex justify-start align-center d-block">
            <AppBtn
              @click.native="submitSSO"
              class="_mr-auto w-100 w-md-auto"
              :disabled="loading"
            >
              <span class="_py-4 _py-sm-3 _px-25 _px-xs-0 _fs-16 _lh-24"
                ><span v-if="loading"
                  ><Preloader
                    style="
                      color: #fff;
                      width: 20px;
                      height: 20px;
                      border-width: 2px;
                      border-color: transparent;
                    " /></span
                ><span v-else>{{ $t("interface.login") }}</span></span
              >
            </AppBtn>
          </div>
        </div>
      </template>
    </Modal>
    <Modal v-if="helpState" @close="modalToggle('helpState', false)">
      <template v-slot:modalBody>
        <div class="modal__body">
          <div
            class="modal__title _fs-sm-24 _lh-sm-32 _fs-24 _lh-32 _fw-700 _tc-dark _mb-6"
          >
            Вы уже посещали наш сайт ранее
          </div>

          <div class="d-md-flex justify-start align-center _mt-8 d-block">
            <AppBtn
              @click.native="modalToggle('authState2', true)"
              class="_mr-4 w-100 w-md-auto"
            >
              <span class="_py-4 _py-sm-3 _px-25 _px-xs-0 _fs-16 _lh-24">
                Да
              </span>
            </AppBtn>
            <AppBtn
              @click.native="modalToggle('registerState2', true)"
              class="_ml-auto w-100 w-md-auto _mt-sm-4"
            >
              <span class="_py-4 _py-sm-3 _px-25 _px-xs-0 _fs-16 _lh-24">
                Нет
              </span>
            </AppBtn>
          </div>
        </div>
      </template>
    </Modal>
    <Modal v-if="authState2" @close="modalToggle('authState2', false)">
      <template v-slot:modalBody>
        <div class="modal__body">
          <div
            class="modal__title _fs-sm-24 _lh-sm-32 _fs-24 _lh-32 _fw-700 _tc-dark _mb-6"
          >
            Вы уже зарегистрированы на сайте
          </div>
          <div class="_fs-16 _lh-24 _fw-400 _mb-6 _tc-dark-grey">
            Вам необходимо ввести свой ID и пароль
          </div>
          <v-input
            :class="{ '_mb-10': !email.state }"
            class="_mb-6"
            v-model="email.value"
            :state="email.state ? null : false"
            clearable
            label-style="label-border"
            :label="$t('fields_labels.herbalifeId')"
            :state-invalid-text="email.error"
          >
            <template v-slot:clear>
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 1L1 13M1 1L13 13"
                  stroke="#B2B4B2"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </template>
          </v-input>
          <v-input
            :class="{ '_mb-6': !password.state }"
            class="_mb-2"
            v-model="password.value"
            :state="password.state ? null : false"
            :type="password.type"
            label-style="label-border"
            :label="$t('fields_labels.password')"
            :state-invalid-text="password.error"
            @change="validate(['password'])"
            @blur="validate(['password'])"
          >
            <template v-slot:icon-append>
              <div @click="showPass">
                <svg
                  v-if="password.type === 'text'"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1152_1106)">
                    <path
                      d="M14.12 14.12C13.8454 14.4147 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.481 9.80385 14.1962C9.51897 13.9113 9.29439 13.5719 9.14351 13.1984C8.99262 12.8248 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2218 9.18488 10.8538C9.34884 10.4859 9.58525 10.1546 9.88 9.88M1 1L23 23M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.6819 3.96914 7.65661 6.06 6.06L17.94 17.94ZM9.9 4.24C10.5883 4.07888 11.2931 3.99834 12 4C19 4 23 12 23 12C22.393 13.1356 21.6691 14.2047 20.84 15.19L9.9 4.24Z"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1152_1106">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <svg
                  v-else
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </template>
          </v-input>
          <div class="d-md-flex justify-start align-center _mt-8 d-block">
            <AppBtn
              @click.native="forgotPasswordClick()"
              :btnClass="'btn_underline-grey'"
            >
              <div class="_fs-16 _lh-24">
                {{ $t("modals.auth.forgot_password") }}
              </div>
            </AppBtn>
            <AppBtn
              @click.native="submit"
              class="_ml-auto w-100 w-md-auto _mt-sm-4"
            >
              <span class="_py-4 _py-sm-3 _px-25 _px-xs-0 _fs-16 _lh-24">{{
                $t("interface.login")
              }}</span>
            </AppBtn>
          </div>
        </div>
      </template>
    </Modal>
    <Modal v-if="registerState" @close="modalToggle('registerState', false)">
      <template v-slot:modalBody>
        <div class="modal__body">
          <div
            class="modal__title _fs-sm-24 _lh-sm-32 _fs-32 _lh-38 _fw-700 _mb-6 _tc-dark"
            v-html="$t('modals.auth.title')"
          ></div>
          <v-input
            :class="{ '_mb-10': !email.state }"
            v-model="email.value"
            :state="email.state ? null : false"
            clearable
            label-style="label-border"
            :label="$t('fields_labels.email_or_id')"
            :state-invalid-text="email.error"
          >
            <template v-slot:clear>
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 1L1 13M1 1L13 13"
                  stroke="#B2B4B2"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </template>
          </v-input>

          <div
            class="_fs-16 _lh-24 _tc-dark-grey _mt-4"
            v-html="$t('modals.register.description')"
          ></div>

          <div
            class="d-flex justify-start align-center _mt-8 _mb-12 direction-column-reverse direction-md-row"
          >
            <AppBtn
              :btnClass="'btn_secondary'"
              class="_mr-auto w-100 w-md-auto"
              @click.native="modalToggle('authState', true)"
            >
              <span class="d-flex align-center _py-4 _py-sm-3 _px-20 _px-xs-0">
                <svg
                  class="_mr-2"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.5 12H5.5M5.5 12L12.5 19M5.5 12L12.5 5"
                    stroke="#629727"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <span class="_fs-16 _lh-24"> {{ $t("interface.back") }}</span>
              </span>
            </AppBtn>
            <AppBtn
              @click.native="checkUserIsset(email.value)"
              class="w-100 w-md-auto _mb-sm-4"
            >
              <div class="_px-xs-0 _py-4 _py-sm-3 _px-6 _fs-16 _lh-24">
                {{ $t("modals.register.create") }}
              </div>
            </AppBtn>
          </div>
          <div class="_fs-16 _lh-24 _tc-dark-grey _mb-2">
            <!-- {{ $t('modals.register.social_title') }} -->
          </div>
          <SocialAuth class="_mb-12" v-if="false" />
          <Telegram :analyticEventPrefix="'reg'" />
        </div>
      </template>
    </Modal>
    <Modal v-if="registerState2" @close="modalToggle('registerState2', false)">
      <template v-slot:modalBody>
        <div class="modal__body">
          <div
            class="modal__title _fs-sm-24 _lh-sm-32 _fs-24 _lh-32 _fw-700 _mb-6 _tc-dark"
          >
            Вам необходимо зарегистрироваться
          </div>
          <div class="_fs-16 _lh-24 _fw-400 _mb-6 _tc-dark-grey">
            Для этого введите свой ID
          </div>
          <v-input
            :class="{ '_mb-10': !email.state }"
            v-model="email.value"
            :state="email.state ? null : false"
            clearable
            label-style="label-border"
            :label="$t('fields_labels.email_or_id')"
            :state-invalid-text="email.error"
          >
            <template v-slot:clear>
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 1L1 13M1 1L13 13"
                  stroke="#B2B4B2"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </template>
          </v-input>

          <div
            class="_fs-16 _lh-24 _tc-dark-grey _mt-4"
            v-html="$t('modals.register.description')"
          ></div>

          <div
            class="d-flex justify-start align-center _mt-8 direction-column-reverse direction-md-row"
          >
            <AppBtn
              :btnClass="'btn_secondary'"
              class="_mr-auto w-100 w-md-auto"
              @click.native="modalToggle('helpState', true)"
            >
              <span class="d-flex align-center _py-4 _py-sm-3 _px-20 _px-xs-0">
                <svg
                  class="_mr-2"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.5 12H5.5M5.5 12L12.5 19M5.5 12L12.5 5"
                    stroke="#629727"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <span class="_fs-16 _lh-24"> {{ $t("interface.back") }}</span>
              </span>
            </AppBtn>
            <AppBtn
              @click.native="checkUserIsset(email.value)"
              class="w-100 w-md-auto _mb-sm-4"
            >
              <div class="_px-xs-0 _py-4 _py-sm-3 _px-6 _fs-16 _lh-24">
                {{ $t("modals.register.create") }}
              </div>
            </AppBtn>
          </div>
          <div class="_fs-16 _lh-24 _tc-dark-grey _mb-2">
            <!-- {{ $t('modals.register.social_title') }} -->
          </div>
          <SocialAuth class="_mb-12" v-if="false" />
          <Telegram
            class="_mt-sm-4 _mt-12"
            v-if="email.error === $t('interface.errors.userNotFound')"
            :analyticEventPrefix="'reg'"
          />
        </div>
      </template>
    </Modal>

    <Modal v-if="notFoundId" @close="modalToggle('notFoundId', false)">
      <template v-slot:modalBody>
        <div class="modal__body">
          <div class="modal__title _fs-20 _lh-24 _fw-600 _tc-dark _mb-4">
            {{ $t("modals.notFoundId.title") }}
          </div>
          <div class="_fs-16 _lh-24 _fw-400 _mb-4 _tc-dark-grey">
            {{ $t("modals.notFoundId.description") }}
          </div>

          <v-input
            :class="{ '_mb-10': !herbalifeId.state }"
            class="_mb-6"
            v-model="herbalifeId.value"
            :state="herbalifeId.state ? null : false"
            clearable
            label-style="label-border"
            :label="$t('fields_labels.herbalifeId')"
            :state-invalid-text="herbalifeId.error"
            @change="validate(['email'])"
          >
            <template v-slot:clear>
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 1L1 13M1 1L13 13"
                  stroke="#B2B4B2"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </template>
          </v-input>

          <AppBtn
            class="_mr-auto w-100 w-md-auto"
            @click.native="social(herbalifeId.value)"
          >
            <span class="d-flex align-center _py-sm-3 _py-4 _px-20 _px-xs-0">
              <span class="_fs-16 _lh-24">{{
                $t("modals.notFoundId.continue")
              }}</span>
            </span>
          </AppBtn>
          <Telegram class="_mt-12" />
        </div>
      </template>
    </Modal>

    <Modal
      v-if="restorePasswordState"
      @close="modalToggle('restorePasswordState', false)"
    >
      <template v-slot:modalBody>
        <div class="modal__body">
          <div class="modal__title _fs-20 _lh-24 _fw-600 _tc-dark _mb-4">
            {{ $t("modals.restorePassword.title") }}
          </div>
          <div class="_fs-16 _lh-24 _fw-400 _mb-4 _tc-dark-grey">
            {{ $t("modals.restorePassword.description") }}
          </div>

          <v-input
            :class="{ '_mb-10': !email.state }"
            class="_mb-6"
            v-model="email.value"
            :state="email.state ? null : false"
            clearable
            label-style="label-border"
            :label="$t('fields_labels.email_or_id')"
            :state-invalid-text="email.error"
            @change="validate()"
          >
            <template v-slot:clear>
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 1L1 13M1 1L13 13"
                  stroke="#B2B4B2"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </template>
          </v-input>

          <AppBtn
            class="_mr-auto w-100 w-md-auto"
            @click.native="resetPassword(email.value)"
          >
            <span class="d-flex align-center _py-sm-3 _py-4 _px-20 _px-xs-0">
              <span class="_fs-16 _lh-24">{{
                $t("modals.restorePassword.send")
              }}</span>
            </span>
          </AppBtn>
          <Telegram class="_mt-12" />
        </div>
      </template>
    </Modal>

    <Modal v-if="needPassword" @close="modalToggle('needPassword', false)">
      <template v-slot:modalBody>
        <div class="modal__body">
          <div class="modal__title _fs-20 _lh-24 _fw-600 _tc-dark _mb-4">
            {{ $t("modals.needPassword.title") }}
          </div>
          <div class="_fs-16 _lh-24 _fw-400 _mb-4 _tc-dark-grey">
            {{ $t("modals.needPassword.description") }}
          </div>

          <v-input
            :class="{ '_mb-10': !password.state }"
            class="_mb-6"
            v-model="password.value"
            :state="password.state ? null : false"
            clearable
            :type="password.type"
            label-style="label-border"
            :label="$t('fields_labels.password')"
            :state-invalid-text="password.error"
            @change="validate(['password'])"
          >
            <template v-slot:clear>
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 1L1 13M1 1L13 13"
                  stroke="#B2B4B2"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </template>
          </v-input>

          <AppBtn
            class="_mr-auto w-100 w-md-auto"
            @click.native="connectSocial()"
          >
            <span class="d-flex align-center _py-sm-3 _py-4 _px-20 _px-xs-0">
              <span class="_fs-16 _lh-24">{{
                $t("modals.needPassword.continue")
              }}</span>
            </span>
          </AppBtn>
          <Telegram class="_mt-12" />
        </div>
      </template>
    </Modal>

    <Modal v-if="setPassword" @close="modalToggle('setPassword', false)">
      <template v-slot:modalBody>
        <div class="modal__body">
          <div class="modal__title _fs-20 _lh-24 _fw-600 _tc-dark _mb-8">
            {{ $t("modals.setPassword.title") }}
          </div>

          <!-- <div class="_fs-16 _fw-500 _lh-24 _tc-dark-grey _mb-4">
            Требования к паролю
          </div>
          <div class="_fs-16 _lh-24 _tc-grey-light _mb-8">
            - Только латинские буквы <br />
            - Минимум 8 символов <br />
            - Минимум одна цифра <br />
          </div> -->

          <v-input
            :class="{ '_mb-8': !password.state }"
            class="_mb-6"
            v-model="password.value"
            :state="password.state ? null : false"
            :type="password.type"
            label-style="label-border"
            :label="$t('fields_labels.password')"
            :state-invalid-text="password.error"
            @blur="checkEqualPasswords"
          >
            <template v-slot:icon-append>
              <div @click="showPass">
                <svg
                  v-if="password.type === 'text'"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1152_1106)">
                    <path
                      d="M14.12 14.12C13.8454 14.4147 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.481 9.80385 14.1962C9.51897 13.9113 9.29439 13.5719 9.14351 13.1984C8.99262 12.8248 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2218 9.18488 10.8538C9.34884 10.4859 9.58525 10.1546 9.88 9.88M1 1L23 23M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.6819 3.96914 7.65661 6.06 6.06L17.94 17.94ZM9.9 4.24C10.5883 4.07888 11.2931 3.99834 12 4C19 4 23 12 23 12C22.393 13.1356 21.6691 14.2047 20.84 15.19L9.9 4.24Z"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1152_1106">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <svg
                  v-else
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </template>
          </v-input>

          <v-input
            :class="{ '_mb-8': !password_repeat.state }"
            class="_mb-6"
            v-model="password_repeat.value"
            :state="password_repeat.state ? null : false"
            :type="password.type"
            label-style="label-border"
            :label="$t('fields_labels.password_repeat')"
            :state-invalid-text="password_repeat.error"
            @blur="checkEqualPasswords"
          >
            <template v-slot:icon-append>
              <div @click="showPass">
                <svg
                  v-if="password.type === 'text'"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1152_1106)">
                    <path
                      d="M14.12 14.12C13.8454 14.4147 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.481 9.80385 14.1962C9.51897 13.9113 9.29439 13.5719 9.14351 13.1984C8.99262 12.8248 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2218 9.18488 10.8538C9.34884 10.4859 9.58525 10.1546 9.88 9.88M1 1L23 23M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.6819 3.96914 7.65661 6.06 6.06L17.94 17.94ZM9.9 4.24C10.5883 4.07888 11.2931 3.99834 12 4C19 4 23 12 23 12C22.393 13.1356 21.6691 14.2047 20.84 15.19L9.9 4.24Z"
                      stroke="#B2B4B2"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1152_1106">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <svg
                  v-else
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                    stroke="#B2B4B2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </template>
          </v-input>

          <AppBtn
            :disabled="!password.value || !password_repeat.value"
            class="_mr-auto w-100 w-md-auto"
            @click.native="register()"
          >
            <span class="d-flex align-center _py-sm-3 _py-4 _px-20 _px-xs-0">
              <span class="_fs-16 _lh-24">{{
                $t("modals.setPassword.continue")
              }}</span>
            </span>
          </AppBtn>
          <Telegram class="_mt-12" />
        </div>
      </template>
    </Modal>

    <Modal v-if="notFoundUser" @close="modalToggle('notFoundUser', false)">
      <template v-slot:modalBody>
        <div class="modal__body">
          <div
            class="modal__title _fs-sm-24 _lh-sm-32 _fs-32 _lh-38 _fw-700 _tc-dark _mb-4"
          >
            {{ $t("modals.notFoundUser.title") }}
          </div>
          <div class="_fs-16 _lh-24 _fw-400 _mb-4 _tc-dark-grey">
            {{ $t("modals.notFoundUser.description") }}
          </div>

          <div
            class="d-flex justify-start align-center _mt-8 direction-column-reverse direction-lg-row"
          >
            <AppBtn
              :btnClass="'btn_secondary'"
              class="_mr-auto w-100 w-md-auto"
              @click.native="modalToggle('notFoundUser', false)"
            >
              <span class="d-flex align-center _py-4 _py-sm-3 _px-20 _px-xs-0">
                <svg
                  class="_mr-2"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.5 12H5.5M5.5 12L12.5 19M5.5 12L12.5 5"
                    stroke="#629727"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <span class="_fs-16 _lh-24">{{ $t("interface.back") }}</span>
              </span>
            </AppBtn>
            <AppBtn class="w-100 w-md-auto _mb-sm-4">
              <div class="_px-xs-0 _py-4 _py-sm-3 _px-8 _fs-16 _lh-24">
                {{ $t("modals.notFoundUser.support") }}
              </div>
            </AppBtn>
          </div>
        </div>
      </template>
    </Modal>

    <Modal
      v-if="restorePasswordSuccess"
      @close="modalToggle('restorePasswordSuccess', false)"
    >
      <template v-slot:modalBody>
        <div class="modal__body">
          <div
            class="modal__title _fs-sm-24 _lh-sm-32 _fs-32 _lh-38 _fw-700 _tc-dark _mb-4"
          >
            {{ $t("modals.restorePassword.title") }}
          </div>
          <div class="_fs-16 _lh-24 _fw-400 _mb-4 _tc-dark-grey">
            {{ $t(`interface.restorePasswordSuccess`) }}
          </div>

          <AppBtn
            class="_mr-auto w-100 w-md-auto"
            @click.native="modalToggle('restorePasswordSuccess', false)"
          >
            <span class="d-flex align-center _py-4 _py-sm-3 _px-20 _px-xs-0">
              <span class="_fs-16 _lh-24">{{ $t("interface.close") }}</span>
            </span>
          </AppBtn>

          <Telegram class="_mt-12" />
        </div>
      </template>
    </Modal>

    <Modal v-if="certModal" @close="modalToggle('certModal', false)">
      <template v-slot:modalBody>
        <div class="_fs-24 _lh-24 _mb-4 _fw-700">
          {{ $t("modals.certificate.title") }}
        </div>
        <div class="_fs-18 _lh-20 _mb-6">
          {{ $t("modals.certificate.description") }}
        </div>
        <v-input
          :class="{ '_mb-10': !certName.state }"
          class="_mb-6"
          v-model="certName.value"
          :state="certName.state ? null : false"
          clearable
          label-style="label-border"
          :label="$t('fields_labels.name_and_surname')"
          :state-invalid-text="certName.error"
          @input="fillUsername"
        >
          <template v-slot:clear>
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 1L1 13M1 1L13 13"
                stroke="#B2B4B2"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </template>
        </v-input>
        <AppBtn
          :disabled="!certName.value"
          @click.native="toCanvas"
          class="_mr-auto w-100 w-md-auto"
        >
          <span class="d-flex align-center _py-sm-3 _py-4 _px-10 _px-xs-0">
            <span class="_fs-16 _lh-24">{{
              $t("modals.certificate.download")
            }}</span>
          </span>
        </AppBtn>
        <CertificateTemplate :certData="certData" />
      </template>
    </Modal>

    <Modal
      :disableOverlay="true"
      v-if="congratModal && SOCKET_MESSAGES !== null && !showDataModal"
      :custom-class="'congrat-modal_vertical'"
      @close="modalToggle('congratModal', false)"
    >
      <template #modalBody>
        <CongratModal :is-vertical="true">
          <template>
            <div class="_mb-5 congrat-modal__img">
              <img
                :src="
                  require(`@/assets/img/achievements/${SOCKET_MESSAGES.slug}.png`)
                "
              />
            </div>
            <div>
              <div class="_mb-4">
                <h2
                  class="congrat-modal__title _fs-24 _lh-32 _fw-700"
                  :class="{ 'text-center': true }"
                >
                  {{ SOCKET_MESSAGES.title }}
                </h2>
              </div>
              <div class="_mb-8">
                <p
                  class="congrat-modal__txt _fs-16 _lh-24 _fw-500"
                  :class="{ 'text-center': true }"
                >
                  {{ SOCKET_MESSAGES.hint }}
                </p>
              </div>

              <AppBtn
                class="_py-2 _px-5 _mx-auto"
                @click.native="closeAchievementModal()"
              >
                <div class="d-flex align-center">
                  <p class="_mr-2">Получить</p>
                  <div class="d-flex align-center" v-if="false">
                    <p class="_mr-1">+{{ SOCKET_MESSAGES.reward }}</p>
                    <img :src="require('@/assets/img/icons/coin-icon.svg')" />
                  </div>
                </div>
              </AppBtn>
            </div>
          </template>
        </CongratModal>
      </template>
    </Modal>

    <Modal
      :disableOverlay="true"
      v-if="herbiModal && SOCKET_MESSAGES !== null && !video && !showDataModal"
      :custom-class="'congrat-modal_horizontal _pt-10 _pl-0'"
      @close="
        SOCKET_MESSAGES.coins ? getCoins() : modalToggle('herbiModal', false)
      "
    >
      <template #modalBody>
        <CongratModal :is-vertical="false">
          <template>
            <div class="_mr-5 _mr-sm-0 _mb-sm-5 _mt-sm-4 congrat-modal__img">
              <img :src="SOCKET_MESSAGES.image" />
            </div>
            <div>
              <div class="_mb-4">
                <h2
                  class="congrat-modal__title _fs-24 _lh-32 _fw-700"
                  :class="{ 'text-center': false }"
                >
                  {{ SOCKET_MESSAGES.title }}
                </h2>
              </div>
              <div class="_mb-8">
                <p
                  class="congrat-modal__txt _fs-16 _lh-24 _fw-500"
                  :class="{ 'text-center': false }"
                  v-html="SOCKET_MESSAGES.description"
                ></p>
              </div>

              <AppBtn
                class="_py-2 _px-5 _mx-sm-auto"
                @click.native="getCoins(true)"
              >
                <div
                  class="d-flex align-center"
                  v-if="SOCKET_MESSAGES.coins !== 0"
                >
                  <p class="_mr-2">{{ SOCKET_MESSAGES.button_title }}</p>
                  <div class="d-flex align-center">
                    <p class="_mr-1">+{{ SOCKET_MESSAGES.coins }}</p>
                    <img :src="require('@/assets/img/icons/coin-icon.svg')" />
                  </div>
                </div>
                <div v-else>
                  <p>{{ SOCKET_MESSAGES.button_title }}</p>
                </div>
              </AppBtn>
            </div>
          </template>
        </CongratModal>
      </template>
    </Modal>

    <CoolLightBox
      class="colllightbox"
      :items="[
        {
          src: video,
          autoplay: false,
          muted: false,
          disablepictureinpicture: true,
        },
      ]"
      :index="index"
      @close="onClose()"
      @on-change="onOpen($event)"
      @on-open="onOpen($event)"
    >
    </CoolLightBox>
    <Alert />
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import Modal from "@/components/UI/Modal";
import axios from "axios";
const defaultLayout = "default";
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

import { bus } from "@/main";
import { mapActions, mapGetters } from "vuex";
import AppBtn from "./components/UI/buttons/AppBtn.vue";
import Alert from "./components/UI/Alert.vue";
import Onboarding from "./components/UI/Onboarding.vue";
import validate from "@/mixins/validate";
import SocialAuth from "./components/UI/auth/SocialAuth.vue";
import Telegram from "./components/UI/auth/Telegram.vue";
import CertificateTemplate from "@/components/CertificateTemplate.vue";
import CongratModal from "@/components/gamification/CongratModal.vue";
import Preloader from "@/components/UI/Preloader";

export default {
  metaInfo() {
    return { title: this.$t("pages.home.title") };
  },
  name: "App",
  components: {
    Modal,
    CoolLightBox,
    AppBtn,
    Alert,
    SocialAuth,
    Telegram,
    CertificateTemplate,
    Onboarding,
    CongratModal,
    Preloader,
  },
  mixins: [validate],
  data: () => ({
    isVideo: null,
    isFile: null,
    watched: false,
    videoTime: 0,
    restorePasswordSuccess: false,
    onboardingState: false,
    restorePasswordState: false,
    authState: false,
    authSSOState: false,
    tgAuth: false,
    helpState: false,
    registerState2: false,
    authState2: false,
    needPassword: false,
    registerState: false,
    notFoundId: false,
    setPassword: false,
    notFoundUser: false,
    registerComplete: false,
    video: "",
    videoCurrentTime: 0,
    index: null,
    videoElement: "",
    targetUID: null,
    certModal: false,
    congratModal: false,
    herbiModal: false,
    certData: { username: null },
    loading: false,
    name: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired", "onlyLetters", "latinOrCyrilic", "minLength2"],
    },
    secondName: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired", "onlyLetters", "latinOrCyrilic", "minLength2"],
    },
    country: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired", "onlyLetters", "latinOrCyrilic", "minLength2"],
    },
    city: {
      value: "",
      state: true,
      error: "",
      rules: ["onlyLetters", "latinOrCyrilic", "minLength2"],
    },
    certName: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired"],
    },
    herbalifeId: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired"],
    },
    email: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired"],
    },
    password: {
      type: "password",
      value: "",
      state: true,
      error: "",
      rules: ["isRequired"],
    },
    password_repeat: {
      type: "password",
      value: "",
      state: true,
      error: "",
      rules: ["isRequired"],
    },
    status: {
      value: "",
      state: true,
      error: "",
      rules: ["isRequired"],
    },
    toPage: null,
    statusList: [
      {
        label: "Я Независимый Партнер",
        value: "Независимый Партнер",
        id: 1,
      },
      {
        label: "Я Привилегированный клиент",
        value: "Привилегированный клиент",
        id: 2,
      },
    ],
  }),
  computed: {
    ...mapGetters(["Rules", "user", "SOCKET_MESSAGES"]),
    layout() {
      const layout = this.$route.meta.layout || defaultLayout;
      return () => import(`@/layouts/${layout}.vue`);
    },
    showDataModal() {
      let result =
        this.user &&
        Object.keys(this.user).length &&
        (!this.user.first_name ||
          !this.user.last_name ||
          !this.user.status ||
          !this.user.ds_mailing_country);
      this.scrollLock(result);
      return result;
    },
  },
  methods: {
    ...mapActions([
      "fetchSession",
      "fetchAlerts",
      "auth",
      "authSso",
      "checkUser",
      "addIDSocial",
      "clearSession",
      "registration",
      "tgLogin",
      "tgRegister",
      "restorePassword",
      "fetchLocale",
      "fetchUserCertificat",
      "SOCKET_SEND_MESSAGE",
      "fetchChangeUserData",
      "SOCKET_CLEAR",
    ]),
    async saveUserData() {
      let obj = {
        first_name: this.user.first_name || this.name.value,
        last_name: this.user.last_name || this.secondName.value,
        ds_mailing_country: this.user.ds_mailing_country || this.country.value,
        ds_mailing_city: this.user.ds_mailing_city || this.city.value,
        status: this.user.status || this.status.value,
      };
      let validateFields = [];
      if (this.user && Object.keys(this.user).length) {
        if (!this.user.first_name) {
          validateFields.push("name");
        }
        if (!this.user.last_name) {
          validateFields.push("secondName");
        }
        if (!this.user.ds_mailing_country) {
          validateFields.push("country");
        }
        if (!this.user.ds_mailing_city) {
          validateFields.push("city");
        }
        if (!this.user.status) {
          validateFields.push("status");
        }
      }

      if (this.validate(validateFields)) {
        // if (this.email.value && !this.user.email) {
        //   const send = await this.sendEmailConfirmCode(this.email.value)
        //   if (send) {
        //     this.modalToggle('confirmEmail', true)
        //   }
        // }
        let res = await this.fetchChangeUserData(obj);
        if (res) {
          this.fetchAlerts({
            alerts: this.$t(`interface.saved`),
            type: "notify",
          });
        }
      }
    },
    closeAchievementModal() {
      this.modalToggle("congratModal", false);
      this.SOCKET_CLEAR();
    },
    getCoins(navigate) {
      if (this.SOCKET_MESSAGES.type === "timer") {
        this.SOCKET_SEND_MESSAGE(
          JSON.stringify({
            event_id: this.SOCKET_MESSAGES.id,
            action: "set_timer",
            duration: 30,
          })
        );
      } else {
        this.SOCKET_SEND_MESSAGE(
          JSON.stringify({
            event_id: this.SOCKET_MESSAGES.id,
            action: "accept",
          })
        );
      }

      if (this.SOCKET_MESSAGES.link && navigate) {
        if (new URL(this.SOCKET_MESSAGES.link).host !== window.location.host) {
          window.open(this.SOCKET_MESSAGES.link, "_blank");
        } else {
          window.open(this.SOCKET_MESSAGES.link, "_self");
        }
      }
      this.modalToggle("herbiModal", false);
    },
    fillUsername() {
      this.$set(this.certData, "username", this.certName.value);
    },
    toCanvas() {
      setTimeout(() => {
        const el = document.querySelector(".certificate-wrap");
        const render_wrap = el.cloneNode(true);
        document.body.append(render_wrap);
        const render = render_wrap.querySelector(".certificate");
        render.classList.add("render");
        html2canvas(render, {
          useCORS: true,
          scrollX: 0,
          scrollY: 0,
          scale: 2,
          size: {
            width: 842,
            height: 595,
          },
        }).then(async function (canvas) {
          await new Promise((resolve) => {
            canvas.toBlob(function (blob) {
              self.cardBlob = blob;
              resolve(self.cardBlob);
              render_wrap.remove();
            }, "image/png");
          });
          let url = URL.createObjectURL(await self.cardBlob);
          let a = document.createElement("a");
          a.style.display = "none";
          document.body.appendChild(a);
          a.href = url;
          a.download = "card.png";
          a.click();
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
          }, 1000);
          a.remove();
        });
      }, 500);
      if (this.certData.slug) {
        this.fetchUserCertificat(this.certData.slug);
      }
    },
    modalToggle(model, state, to) {
      this.email.state = true;
      this.email.error = "";
      this.password.state = true;
      this.password.error = "";
      this.helpState = false;
      this.authState = false;
      this.authState2 = false;
      this.authSSOState2 = false;
      this.registerState = false;
      this.registerState2 = false;
      this.notFoundId = false;
      this.notFoundUser = false;
      this.registerComplete = false;
      this.setPassword = false;

      this[model] = state;

      this.scrollLock(state);
      if (to) {
        this.toPage = to;
      }
      if (model === "authState" && state) {
        if (this.$gtm) {
          this.$gtm.push({
            event: "auth_start",
          });
        }
      }
      if (model === "registerState" && state) {
        if (this.$gtm) {
          this.$gtm.push({
            event: "reg_start",
          });
        }
      }
    },
    scrollLock(state) {
      if (state) {
        document.querySelector("body").style.overflowY = "hidden";
        document.querySelector("html").style.overflowY = "hidden";
      } else {
        document.querySelector("body").style.overflowY = "";
        document.querySelector("html").style.overflowY = "";
      }
    },
    async onOpen(e) {
      const vm = this;
      this.videoElement = document.querySelectorAll(".cool-lightbox-video")[e];
      if (this.videoElement) {
        this.videoElement.play();
        this.videoElement.disablePictureInPicture = true;
        this.videoElement.disableRemotePlayback = true;
        const duration = await new Promise((resolve) => {
          this.videoElement.onloadedmetadata = function () {
            resolve(this.duration);
          };
        });
        if (
          this.videoElement.seekable.length > 0 &&
          this.videoCurrentTime &&
          this.videoCurrentTime < (await duration)
        ) {
          this.videoElement.addEventListener("canplay", function () {
            if (Math.round(this.currentTime) === 0) {
              this.currentTime = vm.videoCurrentTime;
            }
          });

          this.videoTime = Math.round(this.videoCurrentTime);
        }

        this.videoElement.addEventListener("timeupdate", function () {
          if (!this.seeking) {
            // supposedCurrentTime = this.currentTime
            if (this.currentTime > vm.videoCurrentTime) {
              if (vm.videoTime !== Math.round(this.currentTime)) {
                vm.videoTime = Math.round(this.currentTime);
                if (vm.videoTime % 30 === 0 && vm.videoTime > 0) {
                  bus.$emit("onClose", {
                    el: vm.videoElement,
                    uid: vm.targetUID,
                    time: vm.videoTime,
                    noGTM: true,
                  });
                }
              }
            }
          }
        });
        // prevent user from seeking
        this.videoElement.addEventListener("seeking", function () {
          // guard agains infinite recursion:
          // user seeks, seeking is fired, currentTime is modified, seeking is fired, current time is modified, ....
          if (!vm.watched) {
            var delta = this.currentTime - vm.videoTime;
            if (delta > 0.01 && !vm.user.is_internal) {
              this.currentTime = vm.videoTime;
            }
          }
        });

        this.videoElement.addEventListener("ratechange", function () {
          // reset state in order to allow for rewind
          if (this.playbackRate > 1.5 && !vm.user.is_internal) {
            this.playbackRate = 1;
            vm.fetchAlerts({
              alerts: "Выбранная скорость воспроизведения недоступна",
              type: "error",
            });
          }
        });
      }
    },
    onClose() {
      bus.$emit("onClose", {
        el: this.videoElement,
        uid: this.targetUID,
        time: this.videoTime,
      });
      this.index = null;
      this.videoTime = 0;
      this.video = "";
      // if (document.pictureInPictureElement) {
      //   document.exitPictureInPicture();
      // }
    },
    playVideo(src, uid, time, watched, isVideo, isFile, fileName) {
      const extension = src.match(/\.([^.]+)$|$/)[1].toLowerCase()
      if (this.checkIfMobile() && extension === "pdf") {
        console.log(12321321321313132)
        let a = document.createElement("a");
        a.href = src;
        a.target = "_blank";
        a.download = `${fileName.replace(":", "")}.${extension}`;
        document.body.append(a);
        a.click();
        // a.remove();
        // window.open(src, "_blank");
      } else if (isVideo || isFile) {
        this.videoCurrentTime = time;
        this.video = src;
        this.index = 0;
        this.targetUID = uid;
        this.watched = watched;
      }
    },
    checkIfMobile() {
      // Проверка на мобильное устройство
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    async submit() {
      if (this.validate(["email", "password"])) {
        const auth = await this.authorize();
        if (auth) {
          this.modalToggle("authState", false);
          this.$router.push({ name: "Cabinet" });
        }
        if (this.toPage && Object.keys(this.toPage).length) {
          this.$router.push(this.toPage);
        }
      }
    },
    async submitSSO() {
      if (this.validate(["email", "password"])) {
        this.loading = true;
        const isEmail = this.email.value.includes("@");
        let auth = null;
        if (isEmail) {
          auth = await this.authorizeSso();
        } else {
          auth = await this.authorize();
        }
        if (auth && auth.status) {
          this.modalToggle("authSSOState", false);
          this.$router.push({ name: "Cabinet" });
        } else {
          this.$set(
            this.password,
            "error",
            auth.code
              ? this.$t(`interface.errors.${auth.code}`)
              : this.$t(`interface.errors.000`)
          );
          this.$set(this.password, "state", false);
          this.$set(this.email, "state", false);
          setTimeout(() => {
            this.$set(this.password, "error", "");
            this.$set(this.password, "state", true);
            this.$set(this.email, "state", true);
          }, 10000);
        }
        this.loading = false;
        if (this.toPage && Object.keys(this.toPage).length) {
          this.$router.push(this.toPage);
        }
      }
    },
    showPass() {
      this.$set(
        this.password,
        "type",
        this.password.type === "text" ? "password" : "text"
      );
    },
    showCertModal(state, data) {
      this.$set(this, "certData", data);
      this.modalToggle("certModal", state);
    },
    checkEqualPasswords() {
      let state = true;
      let result = this.Rules.notEqual(
        this.password.value,
        this.password_repeat.value,
        "Пароли не совпадают"
      );
      if (typeof result === "string") {
        this.$set(this.password_repeat, "error", result);
        this.$set(this.password_repeat, "state", false);

        this.$set(this.password, "error", result);
        this.$set(this.password, "state", false);

        return;
      } else {
        this.$set(this.password_repeat, "error", "");
        this.$set(this.password_repeat, "state", true);

        this.$set(this.password, "error", "");
        this.$set(this.password, "state", true);
      }
      this.validate(["password"]);
      this.validate(["password_repeat"]);
      return state;
    },
    forgotPasswordClick() {
      this.modalToggle("restorePasswordState", true);
      if (this.$gtm) {
        this.$gtm.push({
          event: "auth_fogot_pass",
        });
      }
    },
    registerClick() {
      this.modalToggle("registerState", true);
      if (this.$gtm) {
        this.$gtm.push({
          event: "auth_reg",
        });
      }
    },
    async authorize() {
      if (this.$gtm) {
        this.$gtm.push({
          event: "auth_click",
          param_value: "email",
        });
      }
      const isEmail = this.email.value.includes("@");
      if (isEmail) {
        const result = await this.auth({
          email: this.email.value,
          password: this.password.value,
        });
        return await result;
      } else {
        const result = await this.auth({
          username: this.email.value,
          password: this.password.value,
        });
        if (await result) {
          if (this.$gtm) {
            this.$gtm.push({
              event: "login",
              param_value: "email_" + this.user.username,
            });
            localStorage.removeItem("auth_type");
          }
        } else {
          if (this.$gtm) {
            this.$gtm.push({
              event: "auth_error",
            });
          }
        }
        return await result;
      }
    },
    async authorizeSso() {
      const result = await this.authSso({
        username: this.email.value,
        password: this.password.value,
        affiliate_agreement: true,
        user_agreement: true,
        privacy_HN: true,
      });
      if (await result) {
        // if (this.$gtm) {
        //   this.$gtm.push({
        //     event: 'login',
        //     param_value: 'email_' + this.user.username,
        //   })
        //   localStorage.removeItem('auth_type')
        // }
      } else {
        // if (this.$gtm) {
        //   this.$gtm.push({
        //     event: 'auth_error',
        //   })
        // }
      }
      return await result;
    },
    async checkUserIsset(email, id) {
      const isEmail = email.includes("@");
      let type = "herbID";
      if (isEmail) {
        type = "email";
      }
      if (this.$gtm) {
        this.$gtm.push({
          event: "reg_click",
          param_value: type,
        });
      }
      const checkUser = await this.checkUser({ email: email, id: id });
      if (checkUser === true) {
        this.modalToggle("setPassword", true);
      } else if (checkUser === 200) {
        this.email.state = false;
        this.email.error = this.$t("interface.errors.userIsset");
        if (this.$gtm) {
          this.$gtm.push({
            event: "reg_error",
          });
        }
      } else {
        this.email.state = false;
        this.email.error = this.$t("interface.errors.userNotFound");
        if (this.$gtm) {
          this.$gtm.push({
            event: "reg_error",
          });
        }
      }
    },
    async social(userId) {
      const userData = userId;
      if (!this.tgAuth) {
        const result = await this.addIDSocial(userData);
        if (result === 401) {
          this.modalToggle("needPassword", true);
        } else {
          if (this.$gtm) {
            this.$gtm.push({
              event: "sign_up",
              param_value:
                localStorage.getItem("auth_type") + "_" + this.user.username,
            });
          }
          this.modalToggle("notFoundId", false);
          this.$router.push({ name: "Cabinet" });
        }
      } else {
        const result = await this.tgRegister(userData);
        if (result === true) {
          this.modalToggle("notFoundId", false);
          if (this.$gtm) {
            this.$gtm.push({
              event: "sign_up",
              param_value: "tg_" + this.user.username,
            });
          }
        } else if (result === 401) {
          this.modalToggle("needPassword", true);
        }
      }
    },
    async connectSocial() {
      const result = await this.auth({
        username: this.herbalifeId.value,
        password: this.password.value,
      });
      if (result) {
        this.modalToggle("needPassword", false);
        if (this.$gtm) {
          this.$gtm.push({
            event: "sign_up",
            param_value:
              localStorage.getItem("auth_type") + "_" + this.user.username,
          });
        }
        localStorage.removeItem("auth_type");
      }
    },
    async register() {
      if (
        this.validate(["password", "password_repeat"]) &&
        this.checkEqualPasswords()
      ) {
        const isEmail = this.email.value.includes("@");
        let type = "herbID_";
        if (isEmail) {
          type = "email_";
        }
        let fields = {
          username: this.email.value,
          password: this.password.value,
        };
        if (localStorage.getItem("referral")) {
          fields.invite_code = localStorage.getItem("referral");
        }
        const result = await this.registration(fields);
        if (result && result.username) {
          localStorage.removeItem("referral");
          this.modalToggle("setPassword", false);
          if (this.$gtm) {
            this.$gtm.push({
              event: "sign_up",
              param_value: type + result.username,
            });
          }
          this.$router.push({ name: "Cabinet" });
        } else {
          if (this.$te(`interface.errors.${result}`)) {
            this.$set(
              this.password,
              "error",
              this.$t(`interface.errors.${result}`)
            );
            this.$set(this.password, "state", false);
            this.$set(
              this.password_repeat,
              "error",
              this.$t(`interface.errors.${result}`)
            );
            this.$set(this.password_repeat, "state", false);
          } else {
            this.$set(
              this.password,
              "error",
              this.$t("interface.errors.passInvalid")
            );
            this.$set(this.password, "state", false);
            this.$set(
              this.password_repeat,
              "error",
              this.$t("interface.errors.passInvalid")
            );
            this.$set(this.password_repeat, "state", false);
          }
        }
      }
    },

    async resetPassword(email) {
      let restore = await this.restorePassword(email);
      if (restore === true) {
        // this.fetchAlerts({
        //   alerts: this.$t(`interface.restorePasswordSuccess`),
        //   type: 'warning',
        // })

        this.modalToggle("restorePasswordState", false);
        this.modalToggle("restorePasswordSuccess", true);
      } else {
        if (restore === 101) {
          this.$set(this.email, "state", false);
          this.$set(this.email, "error", this.$t("interface.errors.101"));
        }
        if (restore === 107) {
          this.$set(this.email, "state", false);
          this.$set(this.email, "error", this.$t("interface.errors.107"));
        }
      }
    },
    closeOnboarding() {
      this.modalToggle("onboardingState", false);
      this.modalToggle("authState", true);
      localStorage.setItem("onboarding", true);
    },
  },
  async mounted() {
    bus.$on("playVideo", this.playVideo);
    bus.$on("scrollLock", this.scrollLock);
    bus.$on("showCertModal", this.showCertModal);

    await axios.interceptors.response.use(
      (response) => {
        return response;
      },
      async (error) => {
        let errorCode = parseInt(error.response.data?.code);
        if (errorCode && this.$te(`interface.errors.${errorCode}`)) {
          this.fetchAlerts({
            alerts: this.$t(`interface.errors.${errorCode}`),
            type: "error",
          });
        } else if (errorCode && !this.$te(`interface.errors.${errorCode}`)) {
          this.fetchAlerts({
            alerts: this.$t(`interface.errors.000`),
            type: "error",
          });
        }
        const originalRequest = error.config;
        if (
          error.response.status === 403 &&
          !originalRequest._retry &&
          !error.config.url.includes("refresh")
        ) {
          localStorage.removeItem("token");
          delete axios.defaults.headers.common.Authorization;
          if (localStorage.getItem("refresh")) {
            originalRequest._retry = true;
            let fd = new FormData();
            fd.append("refresh", localStorage.getItem("refresh"));
            return await fetch(
              `${process.env.VUE_APP_BACKEND_HOST}api/auth/refresh`,
              {
                method: "POST",
                body: fd,
              }
            ).then(async (res) => {
              if (res.status === 200) {
                let result = await res.json();
                // 1) put token to LocalStorage
                localStorage.setItem("token", result.access);
                // 2) Change Authorization header
                axios.defaults.headers.common.Authorization =
                  "Bearer " + result.access;
                originalRequest.headers.Authorization =
                  "Bearer " + result.access;
                // 3) return originalRequest object with Axios.
                return Promise.resolve(await axios.request(originalRequest));
              } else {
                delete axios.defaults.headers.common.Authorization;
                localStorage.removeItem("token");
                localStorage.removeItem("refresh");
                if (this.$route.meta.auth) {
                  this.$router.push(
                    this.helpers.buildRoute({
                      name: "Home",
                      params: { showAuth: true },
                    })
                  );
                }
                return Promise.reject(error);
              }
            });
          } else {
            localStorage.removeItem("token");
            delete axios.defaults.headers.common.Authorization;
            if (this.$route.meta.auth) {
              this.$router.push(
                this.helpers.buildRoute({
                  name: "Home",
                  params: { showAuth: true },
                })
              );
            } //, query:  { back_url: this.$route.path}
          }
        } else if (error.response.status === 403 && originalRequest._retry) {
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          this.clearSession();
          if (this.$route.meta.auth) {
            this.$router.push(
              this.helpers.buildRoute({
                name: "Home",
                params: { showAuth: true },
              })
            );
          }
        }
        return Promise.reject(error);
      }
    );
  },
  created() {
    bus.$on("openAuth", this.modalToggle);
  },
  beforeDestroy() {
    bus.$off("playVideo", this.playVideo);
    bus.$off("scrollLock", this.scrollLock);
    bus.$off("showCertModal", this.showCertModal);
  },
  watch: {
    SOCKET_MESSAGES() {
      if (
        this.SOCKET_MESSAGES &&
        !Array.isArray(this.SOCKET_MESSAGES) &&
        Object.keys(this.SOCKET_MESSAGES) &&
        this.SOCKET_MESSAGES.content_type &&
        this.SOCKET_MESSAGES.content_type === "achievement"
      ) {
        this.herbiModal = false;
        this.congratModal = true;
      }
      if (
        this.SOCKET_MESSAGES &&
        !Array.isArray(this.SOCKET_MESSAGES) &&
        Object.keys(this.SOCKET_MESSAGES) &&
        !this.SOCKET_MESSAGES.content_type
      ) {
        this.congratModal = false;
        this.herbiModal = true;
      }
      if (this.SOCKET_MESSAGES === null) {
        this.congratModal = false;
        this.herbiModal = false;
      }
    },
    "$route.params.showAuth": {
      handler: async function () {
        if (this.$route.params.showAuth && localStorage.getItem("onboarding")) {
          this.modalToggle("authSSOState", true, this.$route.params.toPage);
        }
      },
      deep: true,
      immediate: true,
    },
    "$route.query.token": {
      handler: async function () {
        if (this.$route.query.token) {
          localStorage.setItem("token", this.$route.query.token);
          axios.defaults.headers.Authorization = `Bearer ${this.$route.query.token}`;
          if (
            this.user &&
            !Object.keys(this.user).length &&
            (!process.env.VUE_APP_CLOSED ||
              document.cookie.includes("access")) &&
            localStorage.getItem("token")
          ) {
            await this.fetchSession();
          }
          if (localStorage.getItem("auth_type")) {
            if (this.$gtm) {
              this.$gtm.push({
                event: "login",
                param_value:
                  localStorage.getItem("auth_type") + "_" + this.user.username,
              });
              localStorage.removeItem("auth_type");
            }
          }
        }
      },
      deep: true,
      immediate: true,
    },
    "$route.query": {
      handler: async function () {
        if (
          this.$route.query &&
          this.$route.query.error === "enter-herbalife_id" &&
          !Object.keys(this.user).length
        ) {
          this.notFoundId = true;
        }
        if (this.$route.query.username && !Object.keys(this.user).length) {
          const login = await this.tgLogin(this.$route.query);
          if (login === null) {
            this.notFoundId = true;
            this.tgAuth = true;
          } else if (login) {
            if (this.$gtm) {
              this.$gtm.push({
                event: "login",
                param_value: "tg_" + this.user.username,
              });
              localStorage.removeItem("auth_type");
            }
          }
        }
      },
      deep: true,
      immediate: true,
    },
    async $route(to, from) {
      if (to && to.params && to.params.referral) {
        // this.modalToggle('onboardingState', false)
        // this.modalToggle('registerState', true)
      } else {
        if (!localStorage.getItem("onboarding")) {
          // this.modalToggle('onboardingState', true)
        }
      }
      if (to.path !== from.path) {
        this.scrollLock(false);
      }
      if (
        Object.keys(this.user).length &&
        this.user.language !== this.Trans.currentLocale
      ) {
        if (!this.Trans.isLocaleSupported(this.user?.language)) {
          let to = this.$route;
          this.Trans.changeLocale(this.Trans.defaultLocale).then(async () => {
            await this.fetchLocale(this.Trans.defaultLocale).then(() => {
              to = this.helpers.buildRoute({
                name: to.name,
                params: { ...to.params, locale: this.Trans.defaultLocale },
                query: to.query,
              });
              this.$router.push(to);
            });
          });
        } else {
          this.Trans.changeLocale(this.user.language).then(() => {
            this.$router.push(
              this.helpers.buildRoute({ name: this.$route.name })
            );
          });
        }
      }
    },
    "password_repeat.value": {
      handler: async function () {
        this.checkEqualPasswords();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.congrat-modal_vertical) {
  max-width: 495px;
}

.congrat-modal {
  &__title {
    color: color(dark);

    @media screen and (max-width: 767px) {
      text-align: center;
    }
  }

  &__txt {
    color: color(dark-grey);

    @media screen and (max-width: 767px) {
      text-align: center;
    }
  }

  &__img {
    min-height: 216px;
    max-height: 100%;
    height: 1px;

    @media screen and (max-width: 767px) {
      height: 250px;
    }

    & img {
      height: 100%;
      object-fit: scale-down;
    }
  }
}
</style>

<style lang="scss" scoped>
.filter {
  margin-top: 24px;
  margin-bottom: 64px;
  display: grid;
  grid-template-columns: 280px 280px 176px 176px 176px;
  column-gap: 32px;

  @media screen and (max-width: 1220px) {
    // width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 0;
    margin: 24px -16px 24px;

    & .vmq-input-wrapper {
      width: calc(50% - 32px);
      margin: 0 16px 24px;
    }

    & .selectaria__select.selectaria__select_long {
      width: calc(50% - 32px);
      margin: 0 16px 24px;
    }

    & .v-select {
      width: 33.3333333%;
      margin: 0 16px;
    }
  }

  @media screen and (max-width: 767px) {
    margin: 24px -8px 24px;
    & .vmq-input-wrapper {
      width: calc(100% - 8px);
      margin: 0 4px 16px;
    }

    & .selectaria__select.selectaria__select_long {
      width: calc(100% - 8px);
      margin: 0 4px 16px;
    }

    & .v-select {
      width: calc(50% - 8px);
      margin: 0 4px;
    }
  }
}
</style>
<style lang="scss">
.selectaria {
  width: 100%;
  &__label {
    margin-bottom: 16px;
    font-family: "Helvetica Neue", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #1f1f1f;
  }

  &__select {
    padding: 0 16px;
    width: 100%;
    height: 56px;
    max-width: none;
    border: 1px solid #d4d4d4;
    border-radius: 5px;
    font-family: "Helvetica Neue", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
    color: #707372;
    background-color: #fff;
    display: block;
    transition: 0.3s;
    .vs__dropdown-toggle {
      height: 100%;
      border: none;
      padding: 0;
      .vs__search::placeholder {
        font-family: "Helvetica Neue", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 21px;
        color: #707372;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .vs__search:placeholder-shown {
        text-overflow: ellipsis;
      }
      .vs__search,
      .vs__search:focus {
        margin: 0;
        padding: 0;
        overflow: hidden;
      }
      .vs__clear {
        display: none;
      }

      .vs__selected {
        margin: 0;
        position: static;
        opacity: 1;

        &-options {
          width: 90%;
        }
      }
    }

    .vs__dropdown-option {
      white-space: inherit;
    }
  }
  &__error {
    margin-top: 8px;
    font-family: "Helvetica Neue", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: #cb4050;
  }
  &_error {
    & .selectaria__select {
      border-color: #cb4050;
      background-color: #faebed;
    }
  }
}

.placeholder-immitation {
  position: static;
  font-family: "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  color: #707372;
  display: flex;
  align-items: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  &:first-child {
    padding: 0 5px;
    position: absolute;
    background-color: #fff;
    top: -10px;
    left: -2px;
    display: flex;
    align-items: center;
    line-height: 1.4;
    font-size: 1em;
    font-family: "Helvetica Neue", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 21px;
    color: #707372;
    text-overflow: ellipsis;
    overflow: hidden;
    transition: 0.3s;
  }
}

.placeholder-immitation_overflow {
  height: 54px;
  width: 100%;
  min-width: 0px;

  & span {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.vs__dropdown-option--selected {
  color: #77bb2f !important;
}

.vs__dropdown-option--deselect {
  background: none;
  color: inherit;
}

.vs__dropdown-option--highlight {
  background: none !important;
  color: inherit !important;
}

.vs__dropdown-option:hover {
  background: #77bb2f !important;
  color: #fff !important;
}
.selectaria_error {
  border-color: #cb4050;
  background-color: #faebed;
}
</style>
<style>
.vs__dropdown-option:hover .checkbox__label {
  color: #fff !important;
}

/* .pdf-lightbox-content {
  background-color: white;
  padding: 15px;
  border-radius: 8px;
  max-width: 90%;
  max-height: 90%;
  overflow: auto;
}

.pdf-viewer {
  width: 100%;
  height: 100%;
} */
</style>
